import type { LevelConfig } from '../types'
import { padRow } from '../utils'

export const level2: LevelConfig = {
  grid: [
    [
      'W',
      { track: 'WE', vehicle: { type: 'wagon', color: 'gold' } },
      { track: 'WE', vehicle: { type: 'wagon', color: 'forestgreen' } },
      'SW',
    ],
    [null, null, null, 'NS'],
    padRow(
      [
        null,
        'W',
        { track: 'WE', vehicle: { type: 'wagon', color: 'blue' } },
        ['WE', 'NE'],
        'WE',
        { track: 'WE', vehicle: { type: 'locomotive' } },
        { track: 'WE', exit: 'E' },
      ],
      'append',
    ),
  ],
  goal: { sequence: ['blue', 'gold'] },
}
